import { z } from 'zod';
import { Z_TEXT } from '../../..';
import { Z_CODE_POSTAL } from '../../../etablissement';

export const editOfaInfoStep1FormSchema = z.object({
  denominationUsuelle: z.string().optional(),
  formeJuridique: Z_TEXT(),
  adresse: Z_TEXT(),
  complementAdresse: z.string().optional(),
  codePostal: Z_CODE_POSTAL,
  ville: Z_TEXT(),
});

export type EditOfaInfoStep1FormResult = z.infer<typeof editOfaInfoStep1FormSchema>